import Button from "components/Button";

import ArrowRight from "assets/svgs/arrow-right.svg";

export default function GetStarted() {
  return (
    <article className="max-w-6xl mb-8 mx-auto">
      <a className="block relative" href="https://community.uncovered.com/home">
        <img
          src="https://uncovered.com/wp-content/uploads/2022/02/Workspace-Updates-960-×-250-px-1.png"
          alt="Screenshots of Uncovered pages"
          className="mb-4 max-w-full"
        />
      </a>

      <Button
        emphasis="primary"
        href="https://community.uncovered.com/home"
        height="40"
      >
        Click Here to Explore the Uncovered Community Now{" "}
        <ArrowRight className="ml-2" width="14" />
      </Button>
      <p className="mt-2 text-gray-400 text-xs"></p>
    </article>
  );
}
